export const FETCH_MYTASK_LISTING_REQUEST = 'FETCH_MYTASK_LISTING_REQUEST'
export const FETCH_MYTASK_LISTING_SUCCESS = 'FETCH_MYTASK_LISTING_SUCCESS'
export const FETCH_MYTASK_LISTING_FALUIRE = 'FETCH_MYTASK_LISTING_FALUIRE'
export const FETCH_MYTASK_MINUUS_ONE_LISTING_FALUIRE = 'FETCH_MYTASK_MINUUS_ONE_LISTING_FALUIRE'
export const FETCH_SEARCH_M_TASK='FETCH_SEARCH_M_TASK'
